import React, {ReactNode} from "react";
import {Constants} from "../../../../core/utilities/constants";
import {Images} from "../../../../core/utilities/images";
import "./QuestionHeader.scss";

interface IProps {
  level: number;
}

const QuestionHeader = (props: IProps) => {

  const renderLevel = (level: number): ReactNode => {
    return (
      <div
        key={`level-${level}`}
        className={`level ${level === props.level ? 'current' : ''}`}
      >
        {
          level === 5
            ? <img className="final-icon" src={Images.level_5} alt="final"/>
            : <span>{level}</span>
        }
      </div>
    );
  }

  return (
    <div id="question-header">
      {Array.from(Array(Constants.maxLevel), (_e, i) => {
        return renderLevel(i + 1)
      })}
    </div>
  );
}

export default QuestionHeader;
